/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_LinkInputs */

const en_jobs_link = /** @type {(inputs: Jobs_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link`)
};

const de_jobs_link = /** @type {(inputs: Jobs_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link`)
};

const fr_jobs_link = /** @type {(inputs: Jobs_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lien`)
};

const es_jobs_link = /** @type {(inputs: Jobs_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enlace`)
};

const it_jobs_link = /** @type {(inputs: Jobs_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link`)
};

const nl_jobs_link = /** @type {(inputs: Jobs_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link`)
};

const pl_jobs_link = /** @type {(inputs: Jobs_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link`)
};

const fi_jobs_link = /** @type {(inputs: Jobs_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linkki`)
};

const da_jobs_link = /** @type {(inputs: Jobs_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link`)
};

const sv_jobs_link = /** @type {(inputs: Jobs_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Länk`)
};

/**
* | output |
* | --- |
* | "Link" |
*
* @param {Jobs_LinkInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_link = /** @type {((inputs?: Jobs_LinkInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_LinkInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_link(inputs)
	if (locale === "fr") return fr_jobs_link(inputs)
	if (locale === "es") return es_jobs_link(inputs)
	if (locale === "it") return it_jobs_link(inputs)
	if (locale === "nl") return nl_jobs_link(inputs)
	if (locale === "pl") return pl_jobs_link(inputs)
	if (locale === "fi") return fi_jobs_link(inputs)
	if (locale === "da") return da_jobs_link(inputs)
	if (locale === "sv") return sv_jobs_link(inputs)
	return en_jobs_link(inputs)
});